// extracted by mini-css-extract-plugin
export default {"item":"Item_item__GiUyK","link":"Item_link__wUXrj","icon":"Item_icon__Bnbla","label":"Item_label__jHn-K"};